import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant'
import 'vant/lib/index.css'
import './styles/index.less'
import { createPinia } from 'pinia'
// 数据持久化
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
// 引入全局 Less 文件
import '@/styles/global.less'

const patchDevtoolsNow = () => {
  if (typeof window === 'undefined') {
    return
  }
  const hook = window.__VUE_DEVTOOLS_GLOBAL_HOOK__
  if (!hook || typeof hook.emit !== 'function' || hook.__patchedNowCompat) {
    return
  }

  const rawEmit = hook.emit.bind(hook)
  hook.emit = function (event, ...args) {
    if (event === 'devtools-plugin:setup' && typeof args[1] === 'function') {
      const rawSetup = args[1]
      args[1] = (api) => {
        if (api && typeof api.now !== 'function') {
          api.now = () => {
            if (
              typeof performance !== 'undefined' &&
              typeof performance.now === 'function'
            ) {
              return performance.now()
            }
            return Date.now()
          }
        }
        return rawSetup(api)
      }
    }
    return rawEmit(event, ...args)
  }
  hook.__patchedNowCompat = true
}

patchDevtoolsNow()

const app = createApp(App)
app.use(router)
app.use(Vant)
app.use(pinia)
app.mount('#app')
